export default __webpack_public_path__ + "static/media/img_selected-industry-other.620e75af.svg";